define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'view/AuthenticationOptionView',
	'canvas/LoadingCanvas',
	'amdi18n-loader?!identity/nls/IdentityView_strings',
	'lib/jquery'
], function (
	Util,
	UiUtil,
	AuthenticationOptionView,
	LoadingCanvas,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * BindingViewContainer class
	 */
	return function () {
		var _loadingCanvas = new LoadingCanvas(),
			_loadingOverlay = jQuery("<div id='skIdS_loading-shadow'></div>"),
			_buttons = null,
			_view,
			that = this;

		_loadingOverlay.append(_loadingCanvas.get());

		_view = (function () {
				var $view = jQuery(
					"<div>" +
						"<div id='skIdS_identity-container' class='skIdS_content-body skIdS_column-container'>" +
							"<div id='skIdS_control-column' class='skIdS_column'>" +
								"<div id='skIdS_identity-button-container' style='text-align: center;'>" +
									"<div id='skIdS_toMobile-image-container'>" +
									'<img src=' +UiUtil.getImage("IDS_MOBILE").url()+ ' style="max-width: 100%;">' + 
									"</div>" +
								
									"<div id='skIdS_toMobile-button-container'>" +
									'<img src=' +UiUtil.getImage("IDS_MOBILE").url()+ ' style="max-width: 100%;">' + 
									'<button id="skIdS_toMobile-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
									"</div>" +
									
									"<div id='skIdS_toLocal-button-container'>" +
									'<img src=' +UiUtil.getImage("IDS_LOCAL").url()+ ' style="max-width: 100%;">' + 
									'<button id="skIdS_toLocal-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
									"</div>" +
								"</div>" +
							"</div>" +
							"<div id='skIdS_content-column' class='skIdS_column'>" +
								"<div id='skIdS_identity-content-container'></div>" +
							"</div>" +
						"</div>" +
						"<div id='skIdS_identity-fido_container' style='text-align: center;'>" +
						"<video autoplay muted loop poster='" +UiUtil.getImage('FIDO_ANI_PNG').url()+ "' style='width: 250px;'>" +
							"<source src='" +UiUtil.getImage('FIDO_ANI_MP4').url()+ "' type='video/mp4' />" +
						"</video></div>" +
					"</div>");

				return $view;
			}());

		window.addEventListener('resize', function () {
			if (_buttons !== null) {
				UiUtil.scrollTo(_buttons.get());
			}
		});
		
		var $fidoContainer = _view.find('#skIdS_identity-fido_container');
		$fidoContainer.hide();
		_view.find('#skIdS_toMobile-button-container').hide();
		_view.find('#skIdS_toLocal-button-container').hide();
		_view.find('#skIdS_toMobile-image-container').hide();

		// public methods

		this.get = function () {
			return _view;
		};

		this.changeContent = function (content) {
			var $contentContainer = _view.find('#skIdS_identity-content-container'),
				$content = content.get();

			$contentContainer.children().detach();

			$content.on('touchstart', function () {
				if (_buttons !== null) {
					_buttons.removeActiveStates();
					_buttons.hideButtonMenu();
				}
			});

			$contentContainer
				.prepend($content)
				.find('[autofocus]')
				.focus();
		};
		
		this.showMobileImage = function () {
			_view.find('#skIdS_toMobile-image-container').show();
		};
		
		this.hideMobileImage = function () {
			_view.find('#skIdS_toMobile-image-container').hide();
		};
		
		this.showToMobile = function (callback) {
			that.hideToLocal();
			_view.find('#skIdS_toMobile-button-container').show();
			_view.find('#skIdS_toMobile-button')
				.text(Strings.to_mobile)
				.off('click')
				.on('click', callback);
		};
		
		this.hideToMobile = function () {
			_view.find('#skIdS_toMobile-button-container').hide();
		};
		
		this.showToLocal = function (callback) {
			that.hideToMobile();
			_view.find('#skIdS_toLocal-button-container').show();
			_view.find('#skIdS_toLocal-button')
				.text(Strings.to_local)
				.off('click')
				.on('click', callback);
		};
		
		this.hideToLocal = function () {
			_view.find('#skIdS_toLocal-button-container').hide();
		};
		
		this.showFIDOHint = function () {
			$fidoContainer.show();
		};
		
		this.hideFIDOHint = function () {
			$fidoContainer.hide();
		};

		this.showLoadingIndicator = function () {
			if (_view.find('#skIdS_content-column').children().first()[0] !== _loadingOverlay[0]) {
				_view.find('#skIdS_content-column').prepend(_loadingOverlay);
			}

			_loadingCanvas.enableAnimation();
		};

		this.hideLoadingIndicator = function () {
			if (_view.find('#skIdS_content-column').children().first()[0] === _loadingOverlay[0]) {
				_view.find('#skIdS_content-column').children().first().detach();
			}

			_loadingCanvas.disableAnimation();
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/bindings/BindingViewContainer.js
// module id = 360
// module chunks = 1